import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../../lib/api';
import type { OneCSync_Response } from '../../types/onec-sync.types';

/**
 * Hook for triggering 1C directories synchronization
 * Синхронизирует справочники из 1С (подразделения, должности, графики, сотрудников)
 */
export const useSync1CDirectories = () => {
  return useMutation({
    mutationFn: async (): Promise<OneCSync_Response> => {
      const response = await apiClient.sync1CDirectories();
      return response;
    },
  });
};
